module.exports = __webpack_public_path__ + "img/kandian@2x.cc980edc.png";